/**
 * 充值签收弹窗 — 业务逻辑
 */

/** 弹窗展示类型 */
export const RECHARGE_CLAIM_TYPE = {
  RECHARGE: 'recharge', // 充值引导
  REDEEMED: 'redeemed', // 充值成功
}

/**
 * 各类型 UI 配置（按 type 切换）
 * 文案只保存 translation key，实际文案通过 computed + t() 获取
 */
export const RECHARGE_CLAIM_VIEW_CONFIG = {
  [RECHARGE_CLAIM_TYPE.RECHARGE]: {
    translationKey: 'recharge',
    titleUppercase: true,
    primaryAction: 'deposit', // 主按钮行为：发起充值
  },
  [RECHARGE_CLAIM_TYPE.REDEEMED]: {
    translationKey: 'redeemed',
    titleUppercase: false,
    primaryAction: 'goHome', // 主按钮行为：跳转游戏
  },
}

/** 按当前 locale 格式化金额：28 -> "28,00" / "28.00" */
export const formatAmount = (value, locale = 'pt-BR') =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0)

export function useRechargeClaim(props, emit) {
  const { t, locale } = useI18n()

  /** 顶部栏背景图 */
  const topBarBgUrl = getImageUrlWithCDN_LOCAL('/home2/pop-up_top_bar_bg.png')
  /** 顶部笑脸装饰 */
  const smileyUrl = getImageUrlWithCDN_LOCAL('/home2/smiley_face_decoration.png')
  /** 气泡装饰 — 右侧 */
  const bubbleRightUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_1.png')
  /** 气泡装饰 — 左下 */
  const bubbleLeftBottomUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_2.png')
  /** 气泡装饰 — 左中 */
  const bubbleLeftMiddleUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_3.png')

  /** 当前类型对应的展示数据 */
  const viewData = computed(() => {
    const config = RECHARGE_CLAIM_VIEW_CONFIG[props.type] || RECHARGE_CLAIM_VIEW_CONFIG[RECHARGE_CLAIM_TYPE.RECHARGE]
    const key = config.translationKey
    const prefix = `home-ad-popup-index.rechargeClaim.${key}`

    return {
      topLabel: t(`${prefix}.topLabel`),
      title: t(`${prefix}.title`),
      titleUppercase: config.titleUppercase !== false,
      descriptionKey: `${prefix}.description`,
      formattedTotalBonus: `${t('CurrencySymbol')} ${formatAmount(props.totalBonus, locale.value)}`,
      formattedDepositAmount: `${t('CurrencySymbol')} ${formatAmount(props.depositAmount, locale.value)}`,
      primaryButton: t(`${prefix}.primaryButton`),
      secondaryButton: t(`${prefix}.secondaryButton`),
      primaryAction: config.primaryAction,
    }
  })

  /** 主按钮点击 */
  const handlePrimaryClick = () => {
    if (props.depositLoading) return

    if (viewData.value.primaryAction === 'deposit') {
      emit('deposit', { depositAmount: props.depositAmount })
      return
    }

    if (viewData.value.primaryAction === 'goHome') {
      emit('goHome')
    }
  }

  /** 底部按钮 — 关闭弹窗 */
  const handleLater = () => {
    if (props.depositLoading) return
    emit('close')
  }

  return {
    topBarBgUrl,
    smileyUrl,
    bubbleRightUrl,
    bubbleLeftBottomUrl,
    bubbleLeftMiddleUrl,
    viewData,
    handlePrimaryClick,
    handleLater,
  }
}
